import React, { useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Form } from 'react-bootstrap';
import Select from 'react-select';
import './formularioVisita.css';
import {
  selectFormAtividades,
  DropdownIndicator,
  customStyles,
} from '~/Styles/reactSelectStyles';
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from '@material-ui/pickers';
import { MASK_DATE, PROVEDOR_CALENDARIO_EXTERNO } from '~/constant';
import MaskedInput from 'react-text-mask';
import DateMask from '../DateMask';
import { useEffect } from 'react';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import Loading from '../Loading';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import AuthStorage from '~/Utils/AuthStorage';
import { FaWindowClose } from 'react-icons/fa';
import { TextField } from '@material-ui/core';

const VisitaFormSchema = Yup.object().shape({
  data: Yup.string()
    .nullable()
    .required('A Data de conclusão é obrigatória'),
  descricao: Yup.string().required('Descrição é obrigatória'),
  situacao: Yup.string().required('Situação é obrigatória'),
  tipoResponsavel: AuthStorage.isCorretor()
    ? Yup.string()
    : Yup.string().required('Tipo de Responsável é obrigatório'),
  responsavel: AuthStorage.isCorretor()
    ? Yup.string()
    : Yup.string().required('Responsável é obrigatório'),
  visitaVirtual: Yup.string().required('Visita virtual é obrigatória'),
  tipoVisita: Yup.string().required('Tipo de Visita é obrigatório'),
  recalcularVencimento: Yup.string().required(
    'Recalcular vencimento do lead é obrigatório'
  ),
  formasNotificacoes: Yup.string(),
});

const FormularioVisita = ({
  onSubmit,
  initialValues,
  modoEdicao,
  readOnly = false,
  salvandoDados,
  closeModal,
}) => {
  const [buscandoDados, setBuscandoDados] = useState(false);
  const [responsavelOptions, setResponsavelOptions] = useState(null);
  const [atendentesOptions, setAtendentesOptions] = useState(null);
  const [pdvOptions, setPdvOptions] = useState(null);
  const [optionsCorretores, setOptionsCorretores] = useState(
    useSelector(state => state.corretor).listaCorretores.map(cor => ({
      value: cor.codigo + ' - ' + cor.nome,
      label: cor.nome,
    }))
  );
  const isIOS = () => {
    if (typeof navigator === 'undefined') return false;

    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  };

  const buscarOptionsSelect = async () => {
    try {
      setBuscandoDados(true);
      let responseCAV = await api.getAtendentesCAV();
      if (responseCAV) {
        const options = responseCAV.map(atendente => ({
          value: atendente.codigo + ' - ' + atendente.descricao,
          label: atendente.descricao,
        }));

        setAtendentesOptions(options);

        if (modoEdicao) {
          switch (initialValues.tipoResponsavel) {
            case 'Atendente':
              setResponsavelOptions(options);
              break;
            case 'Corretor':
              setResponsavelOptions(optionsCorretores);

              break;
          }
        }
      }

      let responsePDV = await api.getPDV();
      if (responsePDV) {
        const options = responsePDV.map(pdv => ({
          value: pdv.codigo + ' - ' + pdv.descricao,
          label: pdv.descricao,
        }));
        setPdvOptions(options);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setBuscandoDados(false);
    }
  };

  useEffect(() => {
    buscarOptionsSelect();
  }, []);

  const situacaoOptions = [
    { value: 'Pendente', label: 'Pendente' },
    { value: 'Concluído', label: 'Concluído' },
    { value: 'Em Andamento', label: 'Em Andamento' },
    { value: 'Cancelado', label: 'Cancelado' },
    { value: 'Vencido', label: 'Vencido' },
  ];

  const tipoResponsavelOptions = [
    { value: 'Atendente', label: 'Atendente' },
    { value: 'Corretor', label: 'Corretor' },
  ];

  const visitaVirtualOptions = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const tipoVisitaOptions = [
    { value: 'Presencial', label: 'Presencial' },
    { value: 'Conhecimento', label: 'Conhecer as áreas externas' },
    { value: 'Espontânea', label: 'Espontânea' },
  ];

  const recalcularVencimentoOptions = [
    { value: 'Sim', label: 'Sim' },
    { value: 'Não', label: 'Não' },
  ];

  const formaNotificacaoOptions = [
    { value: 'SMS', label: 'SMS' },
    { value: 'Email', label: 'Email' },
  ];

  const montarDadosSubmit = values => {
    const dadosSubmit = { ...values };

    if (AuthStorage.isCorretor()) {
      dadosSubmit.tipoResponsavel = 'Corretor';
      dadosSubmit.responsavel =
        AuthStorage.getUser().usuario + ' - ' + AuthStorage.getUser().nome;
    }

    return dadosSubmit;
  };

  const salvarFormularioSemAgendaExterna = values => {
    const dadosSubmit = montarDadosSubmit(values);

    onSubmit({
      ...dadosSubmit,
      sincronizarCalendario: PROVEDOR_CALENDARIO_EXTERNO.NENHUM,
    });
  };

  return (
    <>
      {!buscandoDados && (
        <Formik
          initialValues={initialValues}
          validationSchema={VisitaFormSchema}
          onSubmit={salvarFormularioSemAgendaExterna}
        >
          {({ errors, touched, setFieldValue, values, handleSubmit }) => (
            <Form className="mt-3" onSubmit={handleSubmit}>
              <Row>
                <Col md={12}>
                  <div className="form-group">
                    <label className="label-form-visita">Descrição</label>
                    <input
                      name="descricao"
                      type="text"
                      value={values.descricao}
                      onChange={e => setFieldValue('descricao', e.target.value)}
                      className={`form-control ${
                        errors.descricao && touched.descricao
                          ? 'is-invalid'
                          : ''
                      }`}
                      readOnly={readOnly}
                    />
                    {errors.descricao && touched.descricao && (
                      <div className="invalid-feedback">{errors.descricao}</div>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <div className="form-group">
                      <label className="label-form-tarefas">Data e Hora</label>
                      <div className="pb-2 d-flex align-items-center">
                        {!isIOS() ? (
                          <KeyboardDateTimePicker
                            style={{
                              display: 'block',
                              width: '100%',
                              height: 'calc(1.5em + 0.75rem + 2px)',
                              padding: '0.375rem 0.75rem',
                              fontSize: '1rem',
                              fontWeight: 400,
                              lineHeight: 1.5,
                              color: '#495057',
                              backgroundColor: '#fff',
                              backgroundClip: 'padding-box',
                              border: '1px solid #ced4da',
                              borderRadius: '0.25rem',
                            }}
                            clearable
                            clearLabel="limpar"
                            showTodayButton={true}
                            todayLabel="agora"
                            cancelLabel="cancelar"
                            invalidDateMessage="Data inválida"
                            ampm={false}
                            name="data"
                            value={values.data || null}
                            onChange={date => {
                              if (date) {
                                setFieldValue(
                                  'data',
                                  date.format('YYYY-MM-DD HH:mm')
                                );
                              } else {
                                setFieldValue('data', null);
                              }
                            }}
                            format="DD/MM/YYYY HH:mm"
                            disabled={readOnly}
                            fullWidth
                          />
                        ) : (
                          <TextField
                            type="datetime-local"
                            value={
                              values.data
                                ? moment(values.data).format('YYYY-MM-DDTHH:mm')
                                : ''
                            }
                            onChange={e => {
                              const inputValue = e.target.value;
                              if (!inputValue) {
                                setFieldValue('data', null);
                                return;
                              }

                              const parsed = moment(
                                inputValue,
                                'YYYY-MM-DDTHH:mm',
                                true
                              );
                              setFieldValue(
                                'data',
                                parsed.isValid()
                                  ? parsed.format('YYYY-MM-DD HH:mm')
                                  : null
                              );
                            }}
                            fullWidth
                            disabled={readOnly}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                              style: {
                                fontSize: '1rem',
                                fontWeight: 400,
                                lineHeight: 1.5,
                                color: '#495057',
                                padding: '0.375rem 0.75rem',
                              },
                            }}
                            style={{
                              backgroundColor: readOnly ? '#e9ecef' : '#fff',
                              border: '1px solid #cccccc',
                              borderRadius: '0.25rem',
                              height: 'calc(1.5em + 0.75rem + 2px)',
                              padding: '0.5rem 0.75rem',
                              fontSize: '1rem',
                              fontWeight: 400,
                              lineHeight: 1,
                              color: '#495057',
                              backgroundColor: '#fff',
                            }}
                          />
                        )}
                      </div>

                      {errors.data && touched.data && (
                        <div className="invalid-feedback d-block">
                          {errors.data}
                        </div>
                      )}
                    </div>
                  </MuiPickersUtilsProvider>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-visita">Situação</label>
                    <Select
                      options={situacaoOptions}
                      onChange={option =>
                        setFieldValue('situacao', option.value)
                      }
                      className={`react-select ${
                        errors.situacao && touched.situacao ? 'is-invalid' : ''
                      }`}
                      value={
                        situacaoOptions.find(
                          opt => opt.value === values.situacao
                        ) || null
                      }
                      isSearchable={false}
                      placeholder={'Selecione a situação...'}
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isDisabled={readOnly}
                    />
                    {errors.situacao && touched.situacao && (
                      <div className="invalid-feedback">{errors.situacao}</div>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-visita">PDV</label>
                    <Select
                      options={pdvOptions ? pdvOptions : []}
                      onChange={option => setFieldValue('pdv', option.value)}
                      className={`react-select ${
                        errors.pdv && touched.pdv ? 'is-invalid' : ''
                      }`}
                      value={
                        pdvOptions
                          ? pdvOptions.find(opt => opt.value === values.pdv) ||
                            null
                          : null
                      }
                      placeholder={'Selecione o PDV...'}
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isDisabled={readOnly}
                    />
                    {errors.pdv && touched.pdv && (
                      <div className="invalid-feedback">{errors.pdv}</div>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-visita">
                      Tipo de Responsável
                    </label>
                    <Select
                      options={tipoResponsavelOptions}
                      onChange={option => {
                        setFieldValue('tipoResponsavel', option.value);
                        switch (option.value) {
                          case 'Atendente':
                            setResponsavelOptions(atendentesOptions);
                            break;
                          case 'Corretor':
                            setResponsavelOptions(optionsCorretores);
                            break;
                        }
                      }}
                      className={`react-select ${
                        errors.tipoResponsavel && touched.tipoResponsavel
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        AuthStorage.isCorretor()
                          ? { value: 'Corretor', label: 'Corretor' }
                          : tipoResponsavelOptions.find(
                              opt => opt.value === values.tipoResponsavel
                            ) || null
                      }
                      isSearchable={false}
                      placeholder={'Selecione o responsável...'}
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isDisabled={readOnly || AuthStorage.isCorretor()}
                    />
                    {errors.tipoResponsavel && touched.tipoResponsavel && (
                      <div className="invalid-feedback">
                        {errors.tipoResponsavel}
                      </div>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-visita">Responsável</label>
                    <Select
                      options={responsavelOptions ? responsavelOptions : []}
                      onChange={option =>
                        setFieldValue('responsavel', option.value)
                      }
                      className={`react-select ${
                        errors.responsavel && touched.responsavel
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        AuthStorage.isCorretor()
                          ? {
                              value:
                                AuthStorage.getUser().usuario +
                                ' - ' +
                                AuthStorage.getUser().nome,
                              label: AuthStorage.getUser().nome,
                            }
                          : responsavelOptions
                          ? responsavelOptions.find(
                              opt => opt.value === values.responsavel
                            ) || null
                          : null
                      }
                      placeholder={'Selecione o responsável...'}
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isDisabled={readOnly || AuthStorage.isCorretor()}
                    />
                    {errors.responsavel && touched.responsavel && (
                      <div className="invalid-feedback">
                        {errors.responsavel}
                      </div>
                    )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-visita">Visita Virtual</label>
                    <Select
                      options={visitaVirtualOptions}
                      onChange={option =>
                        setFieldValue('visitaVirtual', option.value)
                      }
                      className={`react-select ${
                        errors.visitaVirtual && touched.visitaVirtual
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        visitaVirtualOptions.find(
                          opt => opt.value === values.visitaVirtual
                        ) || null
                      }
                      isSearchable={false}
                      placeholder={'Selecione...'}
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isDisabled={readOnly}
                    />
                    {errors.visitaVirtual && touched.visitaVirtual && (
                      <div className="invalid-feedback">
                        {errors.visitaVirtual}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-visita">
                      Recalcular vencimento do lead
                    </label>
                    <Select
                      options={recalcularVencimentoOptions}
                      onChange={option =>
                        setFieldValue('recalcularVencimento', option.value)
                      }
                      className={`react-select ${
                        errors.recalcularVencimento &&
                        touched.recalcularVencimento
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        recalcularVencimentoOptions.find(
                          opt => opt.value === values.recalcularVencimento
                        ) || null
                      }
                      isSearchable={false}
                      placeholder={'Selecione...'}
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isDisabled={readOnly}
                    />
                    {errors.recalcularVencimento &&
                      touched.recalcularVencimento && (
                        <div className="invalid-feedback">
                          {errors.recalcularVencimento}
                        </div>
                      )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-visita">
                      Selecione ou não notificar
                    </label>
                    <Select
                      isMulti={true}
                      options={formaNotificacaoOptions}
                      onChange={selectedOptions => {
                        setFieldValue(
                          'formasNotificacoes',
                          selectedOptions
                            ? selectedOptions
                                .map(option => option.value)
                                .join(',')
                            : ''
                        );
                      }}
                      className={`react-select ${
                        errors.formasNotificacoes && touched.formasNotificacoes
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        values.formasNotificacoes
                          ? formaNotificacaoOptions.filter(opt =>
                              values.formasNotificacoes
                                .split(',')
                                .includes(opt.value)
                            )
                          : []
                      }
                      isSearchable={false}
                      placeholder={'Selecione...'}
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isDisabled={readOnly}
                    />
                    {errors.formasNotificacoes &&
                      touched.formasNotificacoes && (
                        <div className="invalid-feedback">
                          {errors.formasNotificacoes}
                        </div>
                      )}
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <label className="label-form-visita">Tipo de Visita</label>
                    <Select
                      options={tipoVisitaOptions}
                      onChange={option =>
                        setFieldValue('tipoVisita', option.value)
                      }
                      className={`react-select ${
                        errors.tipoVisita && touched.tipoVisita
                          ? 'is-invalid'
                          : ''
                      }`}
                      value={
                        tipoVisitaOptions.find(
                          opt => opt.value === values.tipoVisita
                        ) || null
                      }
                      isSearchable={false}
                      placeholder={'Selecione...'}
                      styles={selectFormAtividades}
                      components={{ DropdownIndicator }}
                      isDisabled={readOnly}
                    />
                    {errors.tipoVisita && touched.tipoVisita && (
                      <div className="invalid-feedback">
                        {errors.tipoVisita}
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
              <hr className="my-4" />
              <div className="d-flex justify-content-end">
                <Button
                  className="btn-light-color"
                  size="sm"
                  type="submit"
                  disabled={readOnly || salvandoDados}
                >
                  Salvar
                </Button>

                <Button
                  variant="light"
                  size="sm"
                  type="button"
                  className="d-inline-flex align-items-center ml-2"
                  onClick={() => {
                    closeModal();
                  }}
                  disabled={salvandoDados}
                >
                  <FaWindowClose />
                  <span className="ml-2 d-xs-none">Fechar</span>
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      )}
      {buscandoDados && <Loading label="Carregando dados..." />}

    </>
  );
};

export default FormularioVisita;
